/**
 * JU!CE — Header: scroll (transparente → sólido na home e na PDP), contador da sacola,
 * e religamento dos gatilhos genéricos do Victory que a section "header" antiga
 * é quem instanciava.
 *
 * Por que "religar" e não reimplementar:
 * - O predictive search (assets/component-predictive-search.build.js) e o cart
 *   drawer (assets/cart-8a5a1588.js) já são globais e não dependem da section
 *   "header". O que dependia dela era só a CHAMADA do utilitário genérico e
 *   reaproveitável window.themeCore.utils.Toggle({ toggleSelector: '...' }) —
 *   feita dentro de initDrawers() em assets/section-header.build.js, que só
 *   roda para elementos achados dentro de ".header-section" (a section
 *   "header" da Victory). Como esta seção troca "header" por "jp-header", essa
 *   função nunca roda, e ninguém mais cria o Toggle('searchToggleDrawer').
 * - O Toggle('CartDrawer') NÃO tem esse problema: quem cria é o próprio
 *   assets/cart-8a5a1588.js, disparado pela section "cart-drawer" (mantida em
 *   sections/header-group.json), independente do header. Por isso o botão da
 *   sacola funciona só com data-target="CartDrawer" data-js-toggle="CartDrawer",
 *   sem nada aqui.
 * - O drawer "Menu" (nosso, novo) reaproveita a MESMA fábrica Toggle — não é
 *   um drawer escrito do zero: ganha de graça overlay, scroll-lock, foco preso
 *   (window.themeCore.utils.trapFocus) e fechar com Esc, que é a lógica que o
 *   Victory já usa em todo modal/drawer do tema.
 */
(function () {
  'use strict';

  var SCROLL_THRESHOLD = 40;
  var scrollInitDone = false;

  function initScroll() {
    if (scrollInitDone) return;
    var header = document.querySelector('[data-jp-header]');
    // data-transparent="true" = home ou PDP (as duas ligam o mesmo scroll → sólido;
    // só a home também sai do fluxo via .jp-header--overlay, isso é CSS puro).
    if (!header || header.dataset.transparent !== 'true') return;
    scrollInitDone = true;

    var ticking = false;
    function apply() {
      ticking = false;
      header.classList.toggle('jp-header--scrolled', window.scrollY > SCROLL_THRESHOLD);
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(apply);
    }
    apply();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function initCartCount() {
    var nodes = document.querySelectorAll('[data-jp-cart-count]');
    if (!nodes.length) return;

    function setCount(count) {
      var n = Number(count) || 0;
      var text = n > 99 ? '99+' : String(n);
      nodes.forEach(function (node) {
        node.textContent = text;
        node.setAttribute('data-cart-count', n);
      });
    }

    if (window.themeCore && window.themeCore.EventBus) {
      window.themeCore.EventBus.listen('cart:updated', function (event) {
        if (!event || !Object.prototype.hasOwnProperty.call(event, 'item_count')) return;
        setCount(event.item_count);
      });
    }
  }

  function initSearchToggle() {
    if (!(window.themeCore && window.themeCore.utils && window.themeCore.utils.Toggle)) return;
    // Evita registrar duas vezes se a section rodar mais de uma vez (theme editor).
    if (window.themeCore.utils.__jpSearchToggleReady) return;
    window.themeCore.utils.__jpSearchToggleReady = true;

    var input = document.querySelector('.js-predictive-search-input');
    window.themeCore.utils.Toggle({
      toggleSelector: 'searchToggleDrawer',
      toggleTabIndex: true,
      elementToFocus: input || null
    }).init();
  }

  function initMenuDrawer() {
    if (!(window.themeCore && window.themeCore.utils && window.themeCore.utils.Toggle)) return;
    if (window.themeCore.utils.__jpMenuDrawerReady) return;
    window.themeCore.utils.__jpMenuDrawerReady = true;

    window.themeCore.utils.Toggle({
      toggleSelector: 'jpMenuDrawer',
      toggleTabIndex: true,
      overlayPlacement: document.body
    }).init();
  }

  /* 15/09 (revisão): o drawer cobre a viewport inteira, então clicar "fora" caía nele
     e nada acontecia. Clique na área vazia = mesmo efeito do X. */
  function initDrawerOutsideClick() {
    var drawer = document.getElementById('jpHeaderDrawer');
    if (!drawer || drawer.__jpOutsideReady) return;
    drawer.__jpOutsideReady = true;
    drawer.addEventListener('click', function (event) {
      if (event.target.closest && event.target.closest('.jp-header__drawer-panel')) return;
      var close = drawer.querySelector('.jp-header__drawer-close');
      if (close) close.click();
    });
  }

  function boot() {
    initScroll();
    initCartCount();
    initSearchToggle();
    initMenuDrawer();
    initDrawerOutsideClick();
  }

  if (window.themeCore && window.themeCore.loaded) {
    boot();
  } else {
    document.addEventListener('theme:all:loaded', boot, { once: true });
  }

  // O scroll da home não depende do themeCore — liga já, sem esperar o resto.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScroll);
  } else {
    initScroll();
  }
})();
